export enum ReferralSource {
  Facebook = 'facebook',
  Instagram = 'instagram',
  TikTok = 'tiktok',
  LinkedIn = 'linkedin',
  YouTube = 'youtube',
  GoogleSearch = 'google_search',
  Recommendation = 'recommendation',
  JobBoard = 'job_board',
}

export enum TeachingExperienceYears {
  NoExperience = 'no_experience',
  LessThan1Year = 'less_than_1_year',
  From1To3Years = 'from_1_to_3_years',
  MoreThan3Years = 'more_than_3_years',
}

export enum OnboardingTimeframe {
  Within2Days = 'within_2_days',
  Within5Days = 'within_5_days',
  WithinWeek = 'within_week',
}